// 텔레메트리 gzip+base64 공용 유틸 — trace_json / session_state 전송 인코딩 //
// P2c (2026-06-11): 백엔드는 무해석 저장(디코드 없음, 요청서 3항 합의) — 인코딩·디코딩 책임은 프론트 단독.
// 브라우저(CompressionStream)/Node 18+(글로벌 CompressionStream) 양용. 구행 평문 JSON 하위호환:
// session_state 기존 행은 평문 JSON.stringify — decodeMaybeGzip이 선두 문자로 분기.

// 문자열 → gzip → base64 (async) — 실패 시 null //
export async function gzipBase64(text) {
  try {
    if (typeof text !== 'string') return null;

    const inputBytes = new TextEncoder().encode(text);
    const stream = new Blob([inputBytes]).stream().pipeThrough(new CompressionStream('gzip'));
    const compressed = new Uint8Array(await new Response(stream).arrayBuffer());

    return bytesToBase64(compressed);
  }
  catch (_e) { return null; }
}

// base64 → gunzip → 문자열 (async) — 실패 시 null //
export async function gunzipBase64(b64) {
  try {
    if (typeof b64 !== 'string' || b64.length === 0) return null;

    const bytes = base64ToBytes(b64);

    if (!bytes || bytes.length < 2 || bytes[0] !== 0x1f || bytes[1] !== 0x8b) return null;

    const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));

    return await new Response(stream).text();
  }
  catch (_e) { return null; }
}

// 평문 JSON(구행) / gzip+base64(신행) 혼재 디코드 — 실패 시 원문 반환 (하위호환 핵심) //
export async function decodeMaybeGzip(value) {
  try {
    if (typeof value !== 'string' || value.length === 0) return value;

    // 구행 평문 JSON — JSON.stringify 산출물은 항상 '{' '[' '"' 또는 숫자/리터럴로 시작 //
    const head = value[0];

    if (head === '{' || head === '[' || head === '"') return value;

    const inflated = await gunzipBase64(value);

    return inflated !== null ? inflated : value;
  }
  catch (_e) { return value; }
}

// Uint8Array → base64 (브라우저 btoa 청크 / Node Buffer 분기) //
function bytesToBase64(bytes) {
  if (typeof Buffer !== 'undefined' && typeof Buffer.from === 'function') return Buffer.from(bytes).toString('base64');

  let binary = '';
  const CHUNK = 0x8000;

  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + CHUNK));
  }

  return btoa(binary);
}

// base64 → Uint8Array (브라우저 atob / Node Buffer 분기) — 실패 시 null //
function base64ToBytes(b64) {
  try {
    if (typeof Buffer !== 'undefined' && typeof Buffer.from === 'function') return new Uint8Array(Buffer.from(b64, 'base64'));

    const binary = atob(b64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

    return bytes;
  }
  catch (_e) { return null; }
}
